<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate";
	import type { GdprProps } from "./GdprProps";
	import translations from "./Gdpr.translations.json";
	import { getGlobalSettings } from "../getGlobalSettings";
	import { Locale } from "../../../core/schema/Locale";
	import { tenants } from "../../../core/config/tenants";

	type $$Props = GdprProps;

	const translate = getTranslate(translations);

	const { TENANT_ID, TENANT_LOCALE, WEB_URL } = getGlobalSettings();
	const tenant = tenants[TENANT_ID];

	const localeShortHandMap = {
		[Locale.cs]: "cz",
		[Locale.en]: "en",
	} as const;
</script>

<Layout>
	<section class="container flex flex-col md:items-center">
		<div class="lg:w-[50rem]">
			<h1 class="m-0 mb-4 p-0 font-normal lg:mb-7 lg:leading-[3.25rem]">
				{translate("headline")}
			</h1>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("gatheredDataTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("gatheredData1")} <a href={WEB_URL[TENANT_ID]}>{tenant.domain}vertiflex.eu</a>
				{translate("gatheredData2")}
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("dataTransferTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer2")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("dataTransfer3")} <a href="mailto:info@vertiflex.eu">info@vertiflex.eu</a>
				{translate("dataTransfer4")}
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("thirdPartyTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("thirdParty")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("googleAnalyticsTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics1")}
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics2")}
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics3")}
				<a
					href="http://www.google.com/intl/{localeShortHandMap[TENANT_LOCALE]}/privacy/privacy-policy.html"
					target="_blank"
				>
					policies.google.com/privacy
				</a>.
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("cookiesTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("cookies")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("changesTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("changes")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("behaviorTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("behavior")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="mb-0 text-start text-[1.5rem] font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("liabilityTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("liability")}</p>
		</div>
	</section>
</Layout>
